import ReactDOM from 'react-dom';

import { WeaLicenseSubmit } from 'weaPortalPublic';

import store from './stores';
import Login from './components/login';
import Theme from './components/theme';
import E7FormCloud from './components/login/e7login/formCloud';
import E8FormCloud from './components/login/e8login/formCloud';
import FormCloud from './components/login/simpleLogin/formCloud';

// 执行主题相关方法
window.doThemeAction = (actionName, params = {}, callback) => {
  const portalThemeStore = store.portalThemeStore;
  if (actionName == 'onLoadMain') {
    portalThemeStore.onLoadMain(params, callback); // 加载内容区域
  } else if (actionName == 'onLogout') {
    portalThemeStore.onLogout(params, callback); // 退出
  } else if (actionName == 'onLeftMenuModeChange') {
    portalThemeStore.onLeftMenuModeChange(params.leftMenuMode, callback); // 展开收缩左侧菜单
  } else if (actionName == 'onQuickSearch') {
    portalThemeStore.onQuickSearch(params, callback); // 快捷搜索跳转
  } else if (actionName == 'onLoadEmailMenu') {
    portalThemeStore.onLoadEmailMenu(params, callback); // 加载邮件菜单
  } else if (actionName == 'onThemeChange') {
    portalThemeStore.onThemeChange(params, callback); // 修改主题
  } else if (actionName == 'onThemeTsChange') {
    portalThemeStore.onThemeTsChange(params, callback); // 修改主题特色
  } else if (actionName == 'onColorChange') {
    portalThemeStore.onColorChange(params, callback); // 修改主题颜色
  } else if (actionName == 'onLayoutChange') {
    portalThemeStore.onLayoutChange(params, callback); // 修改主题布局
  } else if (actionName == 'getAccount') {
    portalThemeStore.getAccount(params, callback); // 刷新账号栏
  } else if (actionName == 'onLoadLeftMenuCount') {
    portalThemeStore.onLoadLeftMenuCount(params, callback); // 加载左侧菜单统计数
  }
};

// 加载左侧菜单统计数
window.loadLeftMenuCount = (params, callback) => {
  window.doThemeAction('onLoadLeftMenuCount', params, callback);
};

// 提交license
window.doLicenseSubmit = () => {
  const div = document.createElement('div');
  document.body.appendChild(div);
  ReactDOM.render(
    <WeaLicenseSubmit
      ecId={`${(this && this.props && this.props.ecId) || ''}_WeaLicenseSubmit@wv6e5n`}
      visible={true}
      from="login"
    />,
    div
  );
};

module.exports = {
  store,
  Login,
  Theme,
  E7FormCloud,
  E8FormCloud,
  FormCloud,
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/index.js